import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    pasalpph() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/procure/pasalpph");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    paymentform() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/salesorder/paymentform");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'campaign', 'campaignKey', 'customer', 'customer_id', 'DimCol', 'DimColInfo', 'DimVal', 'ExtrDocNo', 'iscompliment', 'isdiscount', 'issavingrate', 'nomor', 'sales_search', 'tahun', 'tgl1', 'tgl2', 'status', 'uraian', 'createby'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/salesrevorder${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("/salesrevorder", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    attachmentDownload(obj) {
        return new Promise((resolve, reject) => {
            try {
                axios({
                    url: `/salesorder/attachment/${obj.salesHdrKey}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', obj.attchFileNm);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salesrevorder/detail/${obj.revisionkey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    detailsalesorder(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salesorder/detail/${obj.salesHdrKey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`salesrevorder/${obj.revisionkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    } ,   
    print(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salesrevorder/print?revisionkey=${obj.revisionkey}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printSO(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/salesorder/print?salesHdrKey=${obj.salesHdrKey}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'Advertiser', 'brand', 'campaign', 'campaignKey', 'customer', 'customer_id', 'DimCol', 'DimColInfo', 'DimVal', 'ExtrDocNo', 'iscompliment', 'isdiscount', 'issavingrate', 'nomor', 'sales_search', 'tahun', 'tgl1', 'tgl2', 'status', 'uraian', 'createby'];
        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/salesrevorder/exportxls${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sales_order_list.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                console.log('File Name : ', formData.filename);
                const { data } = await axios.post("salesrevorder/send2wf", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`/salesrevorder/send2wfCancel/${obj.revisionkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

}